module.exports = __webpack_public_path__ + "static/media/centri-cat1.29d75ad8.png";